import ChartCard from "../ChartCard";
import dynamic from "next/dynamic";
import {
  getLTVChartOptions,
  getLTVChartSeries,
  initRenewalData,
  LTVChartTabs,
  xAxisInitData,
  yAxisInitData,
} from "./data";
import ChartHeading from "../ChartHeading";
import React, { useEffect, useState } from "react";
import ChartTabItem from "../ChartTabs/ChartTabItem";
import ChartTabs from "../ChartTabs";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import { useCalculatorController } from "../../../context/context";
import { useMetricTable } from "../../../AllMetrics/MetricsTable/useMetricTable";

const ApexCharts = dynamic(() => import("react-apexcharts"), { ssr: false });
const DEFAULT_RENEWAL_FIELD = 1;

const LTVLineChart = () => {
  const [activeTab, setActiveTab] = useState("ARPU");
  const { controller } = useCalculatorController();
  const { isCalcFormSubmitted, renewalFieldsCount } = controller;
  const { tableData } = useMetricTable();
  const width = useWindowWidth();
  const [chartData, setChartData] = useState({
    renewalData: initRenewalData,
    xAxisData: xAxisInitData,
    yAxisData: yAxisInitData,
  });

  const getDataViaActiveTab = () => {
    switch (activeTab) {
      case "ARPU":
        return tableData.arpuRowData;
      case "ARPPU":
        return tableData.arppuRowData;
      case "ARPAS":
        return tableData.arpasRowData;
    }
  };

  useEffect(() => {
    setActiveTab("ARPU");
  }, [controller?.calcFormData?.isTrial]);

  useEffect(() => {
    if (isCalcFormSubmitted) {
      const totalFieldsCount = renewalFieldsCount + DEFAULT_RENEWAL_FIELD;
      const data = getDataViaActiveTab();

      setChartData({
        ...chartData,
        renewalData: data.slice(0, totalFieldsCount),
        xAxisData: {
          min: 1,
          max: totalFieldsCount,
          categoriesLength: totalFieldsCount,
          tickAmount: renewalFieldsCount,
          rotateLabels: renewalFieldsCount > 6,
        },
        yAxisData: {
          min: 0,
          max: data?.at(renewalFieldsCount),
        },
      });
    }
  }, [tableData, isCalcFormSubmitted, activeTab]);

  return (
    <ChartCard>
      <ChartHeading title="Cumulative LTV">
        <ChartTabs>
          {LTVChartTabs.map(({ text }) => (
            <ChartTabItem
              key={text}
              isActive={activeTab === text}
              onClick={() => setActiveTab(text)}
              disabled={!controller?.calcFormData?.isTrial && text === "ARPAS"}
            >
              {text}
            </ChartTabItem>
          ))}
        </ChartTabs>
      </ChartHeading>
      <ApexCharts
        options={getLTVChartOptions(chartData.xAxisData, chartData.yAxisData)}
        type="line"
        series={getLTVChartSeries(chartData.renewalData)}
        height={width > 1024 ? 290 : 342}
      />
    </ChartCard>
  );
};

export default LTVLineChart;
